<div class="similar-datasets" *ngIf="datasets.length > 0">
  <h6 class="similar-datasets--heading">{{ title }}</h6>
  <div class="similar-datasets--carousel-wrapper">
    <app-carousel 
      [items]="datasets" 
      [itemsToShow]="itemsToShow"
      [showDots]="showDots"
      [showArrows]="showArrows"
      [gap]="gap"
    >
      <div 
        *ngFor="let dataset of datasets; let i = index" 
        class="carousel-item"
      >
        <app-asset-card
          [data]="dataset"
          [assetType]="assetType"
        ></app-asset-card>
      </div>
    </app-carousel>
  </div>
</div>

